import { Wallet } from 'lucide-react';
import { BalanceMetricsGrid } from '@widgets/balance/balance-metrics-grid';
import { WithdrawalsLockBanner } from '@features/withdrawal';

interface BalanceBannerProps {
  total: number | null;
  reserved: string | null;
  available: string | null;
}

export function BalanceBanner({ total, reserved, available }: BalanceBannerProps) {
  return (
    <>
      <WithdrawalsLockBanner />
      <div className="surface-card flex flex-col gap-4 sm:gap-6">
        <div className="flex min-w-0 items-start gap-3 sm:gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-secondary sm:h-12 sm:w-12 sm:rounded-2xl">
            <Wallet className="h-5 w-5 text-muted-foreground sm:h-6 sm:w-6" />
          </div>
          <BalanceMetricsGrid
            className="min-w-0 flex-1"
            available={available}
            reserved={reserved}
            total={total}
          />
        </div>
      </div>
    </>
  );
}
